export const booking = (state) => state.booking;

export const bookingList = (state) => state.bookingList;